
import { Component, Input } from '@angular/core';

@Component({
  selector: 'anms-cookie',
  templateUrl: './cookie.component.html',
   standalone: false
})
export class CookieComponent {
  @Input() public isShown: boolean = false;
}